// Libs
import React, { useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useDispatch } from 'react-redux';

// Components
import Image from '../../../Image';

// Hooks
import useUser from '../../../../hooks/useUser';

// Actions
import { ClearReorder } from '../../../../actions/orders';

// Styles
import { useStyles } from './OrderConfirmationStyles';

const PRODUCT_IMAGE_SIZE_DESKTOP = 198;
const PRODUCT_IMAGE_SIZE_TABLET = 198;
const PRODUCT_IMAGE_SIZE_MOBILE = 80;

const OrderConfirmation = ({
  unavailableProducts,
  header,
  description,
  cancelAction,
  confirmAction,
}) => {
  const { isKiteUser } = useUser();
  const { classes, cx } = useStyles({ isKiteUser });
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(ClearReorder());
    };
  }, [dispatch]);

  return (
    <Box className={classes.root}>
      <Typography variant="h2" mb={2}>
        {header}
      </Typography>
      <Typography mb={4}>{description}</Typography>
      <Box className={classes.scrollArea} mb={3}>
        {unavailableProducts.map((product) => (
          <Box key={product.product_id} display={'flex'} gap={2} mb={2}>
            <Image
              src={product.image_link}
              imageContainer={{
                desktop: [PRODUCT_IMAGE_SIZE_DESKTOP],
                tablet: [PRODUCT_IMAGE_SIZE_TABLET],
                mobile: [PRODUCT_IMAGE_SIZE_MOBILE],
              }}
            />
            <Typography className={classes.description} variant="h3">
              {product.product_description}
            </Typography>
          </Box>
        ))}
      </Box>
      <Box display={'flex'} gap={2} justifyContent={'right'}>
        <Button
          variant="outlined"
          className={cx(classes.dialogButton, classes.cancelButton)}
          onClick={cancelAction}>
          No
        </Button>
        <Button
          variant="contained"
          className={cx(classes.dialogButton, classes.yesButton)}
          onClick={confirmAction}>
          Yes
        </Button>
      </Box>
    </Box>
  );
};

export default OrderConfirmation;
